<template src="@/templates/reservations/passengers.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';
import passport from '@/components/partials/passport';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      passengers: [],
      isLoading: true,
      entity: entityStore.state,
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
  },
  methods: {
    formatName(passenger) {
      if (this.entity.name === 'amigo') {
        return `${passenger.salutation} ${passenger.initials} ${passenger.middlename} ${passenger.lastname}`;
      }
      return `${passenger.salutation} ${passenger.initials} ${entityStore.formatPassengerName(passenger)}`;
    },
    fetchData() {
      this.isLoading = true;
      userApi.getPassengers(this.reservationId, (data) => {
        this.passengers = data.passengers;
        this.isLoading = false;
      });
    },
    downloadPassengerDocument(passenger, document) {
      userApi.downloadPassengerDocument(this.reservationId, passenger.id, document);
    },
  },
  components: {
    passport,
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// passengers.vue?56dcd788